import { GET_USER_FAILURE, GET_USER_SUCCESS } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_USER_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case GET_USER_FAILURE:
			return { ...state, isLoading: false, errorData: action.payload, error: true };
		default:
			return { ...state };
	}
};
